<zui-tip-card class="__tip">
  Zerops Object Storage, powered by MinIO, operates on an independent infrastructure as a dedicated service. When you add an Object Storage service, we automatically create a new user and bucket, which are immediately ready for your use.
</zui-tip-card>

<zui-form-section
  [isZen]="isZen"
  [separator]="'none'">

  <span *zuiFormSectionTitle>
    {{ translations.nameTitle }}
  </span>

  <div *zuiFormSectionDesc>
    <zui-docs-text>
      <span [innerHTML]="translations?.nameDesc | safeHtml"></span>
    </zui-docs-text>
  </div>

  <zef-form-field>
    <z-hostname-field
      [label]="translations.nameLabel"
      [placeholder]="translations.namePlaceholder"
      [control]="state?.controls.name"
    />
  </zef-form-field>

</zui-form-section>

@if (objectStorages().length > 1) {
  <zui-separator
    [orientation]="'vertical'"
    [size]="'medium'"
    [spacing]="'medium'"
    [position]="'center'"
  />

  <zui-form-section
    [isZen]="isZen"
    [separator]="'none'">

    <span *zuiFormSectionTitle>
      {{ translations.objectStorageTitle }}
    </span>

    <div *zuiFormSectionDesc>
      <zui-docs-text>
        <span [innerHTML]="translations?.objectStorageDesc | safeHtml"></span>
      </zui-docs-text>
    </div>

    <zef-form-field last>
      <mat-form-field class="__select-field" color="accent">

        <mat-label>{{ translations.objectStorageLabel }}</mat-label>

        <mat-select
          [ngrxEnableFocusTracking]="true"
          [ngrxFormControlState]="state?.controls.location">

          <mat-select-trigger>
            {{ state?.controls.location?.value || defaultObjectStorageName() || translations.objectStorageDefault }}
          </mat-select-trigger>

          @if (!defaultObjectStorageName()) {
            <mat-option [value]="''">
              {{ translations.objectStorageDefault }}
            </mat-option>
          }

          @for (group of objectStorageGroups(); track group[0]) {
            <mat-optgroup [label]="group[0]">
              @for (item of group[1]; track item.id) {
                <mat-option [value]="item.name === defaultObjectStorageName() ? '' : item.name">
                  {{ item.name }}
                </mat-option>
              }
            </mat-optgroup>
          }
        </mat-select>

      </mat-form-field>
    </zef-form-field>

  </zui-form-section>
}

<zui-separator
  [orientation]="'vertical'"
  [size]="'medium'"
  [spacing]="'medium'"
  [position]="'center'"
/>

<zui-form-section
  class="fx:pb-1"
  [isZen]="isZen"
  [separator]="'none'">

  <span *zuiFormSectionTitle>
    {{ translations.policyTitle }}
  </span>

  <div *zuiFormSectionDesc>
    <zui-docs-text>
      <span [innerHTML]="translations?.policyDesc | safeHtml"></span>
    </zui-docs-text>
  </div>

  <zef-form-field last>
    <mat-form-field class="__select-field" color="accent">

      <mat-label>Policy (ACL)</mat-label>

      <mat-select
        [panelClass]="'c-mat-select-long-panel'"
        [ngrxEnableFocusTracking]="true"
        [ngrxFormControlState]="state?.controls.policy">

        <mat-select-trigger>
          {{ aclMap?.[state?.controls.policy?.value] || '—' }}
        </mat-select-trigger>

        <mat-option [value]="acls.Custom">
          <strong>Custom policy</strong> <mat-icon class="__custom-policy-icon">tune</mat-icon>
        </mat-option>

        @for (item of aclItemsVisible; track 'id') {
          <mat-option [value]="item.id">
            {{ item.name }}
          </mat-option>
        }
      </mat-select>

    </mat-form-field>
  </zef-form-field>

  @if (state?.controls.policy?.value === acls.Custom) {
    <zef-form-field last>
      @defer {
        <zui-code-field
          class="__code-field"
          [editorOptions]="{ language: 'json' }"
          [ngrxFormControlState]="state?.controls.rawPolicy"
          [ngrxEnableFocusTracking]="true">
        </zui-code-field>
      }

    </zef-form-field>
  }

</zui-form-section>

<zui-separator
  [orientation]="'vertical'"
  [size]="'medium'"
  [spacing]="'medium'"
  [position]="'center'"
/>

<zui-form-section
  [isZen]="isZen"
  [separator]="'none'">

  <span *zuiFormSectionTitle>
    {{ translations.discTitle }}
  </span>

  <div *zuiFormSectionDesc>
    <zui-docs-text>
      <span [innerHTML]="translations?.discDesc | safeHtml"></span>
    </zui-docs-text>
  </div>

  <zef-form-field last>
    <mat-card class="__card">
      <z-disk-capacity-field
        [maxValue]="diskGBytesMax()"
        [ngrxFormControlState]="state?.controls.diskGBytes"
        [ngrxEnableFocusTracking]="true">
      </z-disk-capacity-field>
    </mat-card>

    @if (state?.controls.diskGBytes?.errors?.lessThanOrEqualTo) {
      <zef-form-hints>
        {{ translations.discMaxError }} {{ diskGBytesMax() }} GB.
      </zef-form-hints>
    }
  </zef-form-field>

</zui-form-section>


<zui-separator
  [orientation]="'vertical'"
  [size]="'medium'"
  [spacing]="'medium'"
  [position]="'center'"
/>

<zui-form-section
  [isZen]="isZen"
  [separator]="'none'">

  <zef-form-field appearance="slide-toggle" last>

    <div class="__cdn-toggle-wrap">
      <mat-slide-toggle
        [ngrxFormControlState]="state?.controls.cdnEnabled"
        class="__cdn-toggle">
        Enable CDN for the bucket?
      </mat-slide-toggle>
    </div>

    <zef-form-hints class="__cdn-toggle-hint">
      <zui-docs-text>
        A <span>storageCdnUrl</span> environment variable will be added at project level. Use it as the path for your storage files instead of <span>apiUrl</span> to serve content via <a data-zui-new-docs="features/cdn">CDN</a>, e.g. <span [innerHTML]="'${storageCdnUrl}/my-bucket/image.png'"></span>
      </zui-docs-text>
    </zef-form-hints>

  </zef-form-field>

</zui-form-section>
